import React, { Suspense, lazy, useState } from 'react';
import { IconButton, Typography } from '@mui/material';
import { observer } from 'mobx-react';
// icons
import FolderOpen from '@mui/icons-material/FolderOpen';
import Settings from '@mui/icons-material/Settings';
import Help from '@mui/icons-material/Help';
import Assignment from '@mui/icons-material/Assignment';
import List from '@mui/icons-material/List';
import ZoomControls from './ZoomControls';
import MultiAlignmentSelector from './MultiAlignmentSelector';
const SettingsDialog = lazy(() => import('./dialogs/SettingsDialog'));
const AboutDialog = lazy(() => import('./dialogs/AboutDialog'));
const MetadataDialog = lazy(() => import('./dialogs/MetadataDialog'));
const TracklistDialog = lazy(() => import('./dialogs/TracklistDialog'));
const InfoArea = observer(({ model }) => {
    const { mouseOverRowName } = model;
    return (React.createElement("div", null,
        React.createElement(Typography, { display: "inline" },
            "Row name: ",
            mouseOverRowName)));
});
const Header = observer(function ({ model }) {
    const [settingsDialogViz, setSettingsDialogViz] = useState(false);
    const [aboutDialogViz, setAboutDialogViz] = useState(false);
    const [detailsDialogViz, setMetadataDialogViz] = useState(false);
    const [tracklistDialogViz, setTracklistDialogViz] = useState(false);
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(IconButton, { onClick: async () => {
                try {
                    model.setData({ tree: '', msa: '' });
                    model.clearSelectedStructures();
                    model.setScrollY(0);
                    model.setScrollX(0);
                    model.setCurrentAlignment(0);
                    await model.setTreeFilehandle(undefined);
                    await model.setMSAFilehandle(undefined);
                }
                catch (e) {
                    console.error(e);
                    model.setError(e);
                }
            } },
            React.createElement(FolderOpen, null)),
        React.createElement(IconButton, { onClick: () => setSettingsDialogViz(true) },
            React.createElement(Settings, null)),
        React.createElement(IconButton, { onClick: () => setMetadataDialogViz(true) },
            React.createElement(Assignment, null)),
        React.createElement(IconButton, { onClick: () => setTracklistDialogViz(true) },
            React.createElement(List, null)),
        React.createElement(Suspense, { fallback: null },
            settingsDialogViz ? (React.createElement(SettingsDialog, { model: model, onClose: () => setSettingsDialogViz(false) })) : null,
            aboutDialogViz ? (React.createElement(AboutDialog, { onClose: () => setAboutDialogViz(false) })) : null,
            detailsDialogViz ? (React.createElement(MetadataDialog, { model: model, onClose: () => setMetadataDialogViz(false) })) : null,
            tracklistDialogViz ? (React.createElement(TracklistDialog, { model: model, onClose: () => setTracklistDialogViz(false) })) : null),
        React.createElement(MultiAlignmentSelector, { model: model }),
        React.createElement(ZoomControls, { model: model }),
        React.createElement(InfoArea, { model: model }),
        React.createElement(Spacer, null),
        React.createElement(IconButton, { onClick: () => setAboutDialogViz(true) },
            React.createElement(Help, null))));
});
function Spacer() {
    return React.createElement("div", { style: { flex: 1 } });
}
export default Header;
//# sourceMappingURL=Header.js.map